import { createSelector } from 'reselect';
import { values, orderBy, keys } from 'lodash';
import { jobsActionTypes } from './../actions/types';
import { cachedRequestByIdReducer } from './helpers';
import { utils } from './../helpers';
import { getJobNameNumber } from './../helpers/job';

const jobs = cachedRequestByIdReducer(
  jobsActionTypes,
  'byId',
  ['byBuildId', 'byJobIds', 'byDispatcherType', 'byJobDate']
);

export default jobs;

const jobState = state => state.jobs;
export const jobsById = state => jobState(state).byId;
export const getJobById = (state, id) => jobsById(state)[id];
export const getJobs = createSelector(
  jobState,
  (jobState) => values(jobState.byId)
);


export const groupJobsByName = createSelector(
  getJobs,
  (jobs) => utils.propertyAccumulatorReducer(jobs, 'name')
);

export const getJobsByName = (state, name) => groupJobsByName(state)[name];

export const jobsByName = createSelector(
  groupJobsByName,
  (jobsByName) => values(jobsByName).reduce(
    (result, jobs) => {
      if (jobs.length === 0) {
        return;
      }

      result[jobs[0].name] =
        orderBy(jobs, d => d.created_at, 'desc');
      return result;
    }, {}
  )
);

export const recentJobsByName = createSelector(
  jobsByName,
  (jobsByName) => keys(jobsByName).reduce((result, jobName) => {
    result[jobName] = jobsByName[jobName].slice(0, 10);
    return result;
  }, {})
);

export const recentJobIdsByName = createSelector(
  recentJobsByName,
  (jobsByNames) => values(jobsByNames).reduce(
    (result, jobs) => {
      if (jobs.length === 0) {
        return;
      }

      result[jobs[0].name] =
        jobs.map(job => job.id);
      return result;
    }, {}
  )
);


export const getRecentJobIds = (state) => {
  const recentJobIds = values(recentJobIdsByName(state));
  if (!recentJobIds) {
    return [];
  }
  return [].concat.apply([], recentJobIds);
};


export const jobIdsByNames = createSelector(
  groupJobsByName,
  (jobsByName) => values(jobsByName).reduce(
    (result, jobs) => {
      if (jobs.length === 0) {
        return;
      }

      result[jobs[0].name] = orderBy(jobs, d => d.id, 'desc').map(job => job.id);
      return result;
    }, {}
  )
);

export const getJobIdsByName = (state, name) =>
  jobIdsByNames(state)[name];


export const getNameNumberJobIdPairs = createSelector(
  getJobs,
  (jobs) => jobs.reduce(
    (result, job) => {
      if (!job) {
        return;
      }
      result[getJobNameNumber(job)] = job.id;
      return result;
    }, {}
  )
);

export const getJobIdNameNumberPairs = createSelector(
  getJobs,
  (jobs) => jobs.reduce(
    (result, job) => {
      if (!job) {
        return;
      }
      result[job.id] = getJobNameNumber(job);
      return result;
    }, {}
  )
);


// WEBPACK FOOTER //
// src/reducers/jobs.js